module.exports = __webpack_public_path__ + "assets/htu-5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-5.jpg
// module id = 1192
// module chunks = 7